import { DateTime } from 'luxon';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import { Colors } from 'src/theme/palette';

// ----------------------------------------------------------------------

// The quarter fleets are currently filing for (the one that just ended) and
// its IFTA deadline: the last day of the month after the quarter ends.
function currentFilingPeriod() {
  const lastQuarterEnd = DateTime.now().startOf('quarter').minus({ days: 1 });
  const due = lastQuarterEnd.plus({ months: 1 }).endOf('month');
  return `Now filing Q${lastQuarterEnd.quarter} ${lastQuarterEnd.year} · due ${due.toFormat('MMM d')}`;
}

type Props = {
  children: React.ReactNode;
};

export default function AuthCenteredLayout({ children }: Props) {
  return (
    <Stack
      component="main"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '100vh',
        px: 2,
        py: 6,
        bgcolor: '#F7F9F7',
      }}
    >
      <Stack
        alignItems="center"
        spacing={4}
        sx={{
          width: 1,
          maxWidth: 432,
          '@media (prefers-reduced-motion: no-preference)': {
            '& > *': {
              animation: 'ifta-rise 480ms cubic-bezier(0.2, 0.7, 0.2, 1) both',
            },
            '& > *:nth-of-type(2)': { animationDelay: '90ms' },
            '& > *:nth-of-type(3)': { animationDelay: '180ms' },
          },
          '@keyframes ifta-rise': {
            from: { opacity: 0, transform: 'translateY(12px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <Box
          sx={{
            width: 1,
            bgcolor: '#FFFFFF',
            borderRadius: 2.5,
            p: { xs: 3, sm: 4 },
            border: '1px solid #E7ECE8',
            boxShadow: `0 16px 48px -20px ${alpha(Colors.greyText, 0.25)}`,
          }}
        >
          {children}
        </Box>

        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', letterSpacing: '0.02em' }}
          data-testid="filing-period"
        >
          {currentFilingPeriod()}
        </Typography>
      </Stack>
    </Stack>
  );
}
